<template>
    <div 
        class="position-relative" 
        v-click-outside="closeDropdown"
        @click="openedDropdown = !openedDropdown">
            <Notifications v-if="openedDropdown" @markAsSeen="markAsSeen"/>
            <span id="notification-red-dot" :data-unread="unread" v-b-tooltip.hover  title="Notifications">
                <button id="notification-header" class="p-0 header-icon" @click="iconClick">
                    <Icon icon="notifications-icon" />
                </button>
            </span>
    </div>
</template>


<script>
import {clickOutside} from "../../directives/clickOutside";
import { mapState } from 'vuex'
import Icon from '../Theme/Icon'
import Notifications from '../../dropdowns/Notifications'
import { database } from '../../firebase'

export default {
    name: 'NotificationsDropdwon',
    components: {
        Icon,
        Notifications
    },
    directives: {
        clickOutside
    },
    mounted(){
        this.$root.$on('bv::dropdown::show', bvEvent => {
            this.closeDropdown()
        })
    },
    computed: {
        ...mapState([
            'notifications'
        ]),
        unread: function () {
            return Boolean(this.notifications.filter(
                notification => !notification.seen
            ).length)

        },
    },
    data() {
        return {
            openedDropdown: false
        }
    },
    methods: {
        iconClick(){
            this.$ga.event('Navbar', 'Notification Bell Click')
            this.$sendMixpanelEvent('Navbar Notification Bell Clicked')
            if(this.openedDropdown) {
                this.markAsSeen()
            }
        },
        closeDropdown: function () {
            if (this.openedDropdown === true) {
                this.openedDropdown = false;
                this.markAsSeen()
            }
        },
        markAsSeen() {
            this.$store.commit('SET', [
                'notifications',
                this.notifications.map(
                    (notification) => {
                        if (!notification.seen) {
                            notification.seen = true
                            database
                                .ref(notification.id)
                                .set({
                                    ...notification,
                                    seen: true
                                })
                                .catch(console.error)
                        }
                        return notification
                    }
                )
            ])
        },
    }
}
</script>